export default __webpack_public_path__ + "static/media/sombrero.d1134403.png";